import {
  InfoModule,
  createInfoServices
} from "./chunk-3M4EKCLJ.mjs";
import "./chunk-NGNAAXSQ.mjs";
export {
  InfoModule,
  createInfoServices
};
